// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"0":"codemirror","3":"react-movable","4":"react-sortable-hoc"}[chunkId] || chunkId) + ".min.js?" + {"0":"22f0a346d577456d4134","3":"c69039441855ae418e76","4":"4640e65ae4b15e314532","5":"1a8cebba8906330d668a"}[chunkId] + "";
};